export default async function ({ app, store, redirect, route }) {
    const user = store.getters['user/user']
    if (route.path !== '/welcome') {
        if (!user || (user && !user.verified)) {
        // if (!user) {
            return redirect(200, '/welcome')
        }
    }
}